import React from 'react'

const Benifits = () => {
    return (
        <>
            <div className="benefit-section-four">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 m-auto">
                            <div className="heading-box text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Benefits
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Our Employee Benefits Packages
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-40">
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="benefit-box-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="benefit-icon-four">
                                    <svg
                                        width={34}
                                        height={18}
                                        viewBox="0 0 34 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3.13379 1V17"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M30.8662 1V17"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M17 1V9.53333"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1 1H33"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M3.13379 9.53333H30.8671"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M8.4668 5.26666H11.6668"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M22.333 5.26666H25.533"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <h4>Parental Leave</h4>
                                <p className="lead">We guarantee to provide affordable business.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="benefit-box-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="benefit-icon-four">
                                    <svg
                                        width={28}
                                        height={24}
                                        viewBox="0 0 28 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.09082 12H7.09082L9.09082 9.00002L13.0908 15L15.0908 12H18.0908"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.09082 8C1.09082 7.91625 1.09082 7.83375 1.09082 7.75C1.09082 5.95979 1.80198 4.2429 3.06785 2.97703C4.33372 1.71116 6.05061 1 7.84082 1C10.6646 1 13.0833 2.53875 14.0908 5C15.0983 2.53875 17.5171 1 20.3408 1C22.131 1 23.8479 1.71116 25.1138 2.97703C26.3797 4.2429 27.0908 5.95979 27.0908 7.75C27.0908 16 14.0908 23 14.0908 23C14.0908 23 8.84082 20.175 5.01832 16"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <h4>Health Insurance</h4>
                                <p className="lead">
                                    We stay up-to-date with the latest technology trends.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="benefit-box-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="benefit-icon-four">
                                    <svg
                                        width={30}
                                        height={24}
                                        viewBox="0 0 30 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2.16895 9.1818H27.8313L15.0001 1.28569L2.16895 9.1818Z"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M6.11719 9.18181V19.052"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12.0391 9.18179V19.0519"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M17.9609 9.18179V19.0519"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M23.8828 9.18179V19.0519"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M3.15527 19.052H26.8436"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.18164 23H28.818"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <h4>Financial Benefit</h4>
                                <p className="lead">
                                    We specialize in serving specific industries such.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="benefit-box-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="benefit-icon-four">
                                    <svg
                                        width={26}
                                        height={22}
                                        viewBox="0 0 26 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13.0908 0.923065V21.0769"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M10.3428 21.0769H15.8393"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M4.8457 6.41955L21.3352 2.75522"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.18164 15.5804C1.18164 17.6038 3.47185 18.3286 4.84598 18.3286C6.2201 18.3286 8.51031 17.6038 8.51031 15.5804L4.84598 6.41956L1.18164 15.5804Z"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M17.6709 11.9161C17.6709 13.9395 19.9611 14.6643 21.3352 14.6643C22.7094 14.6643 24.9996 13.9395 24.9996 11.9161L21.3352 2.75522L17.6709 11.9161Z"
                                            stroke="#3B4443"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <h4>Flexible Hours</h4>
                                <p className="lead">
                                    Our solutions are scalable and can grow business.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Benifits
